document.addEventListener('DOMContentLoaded', function() {

    let scroll_pos = window.pageYOffset || window.scrollY,
        out = false;
    
    const el = document.getElementsByClassName('js-topbar')[0];
    let el_height = el.clientHeight;
    
    let visible = false,
    	ww = window.innerWidth,
    	startpoint = 0;
    
    const action = function() {
        scroll_pos = window.pageYOffset || window.scrollY;
        el_height = el.clientHeight;
        ww = window.innerWidth;
        
        if (ww >= 1360) {
            startpoint = 110;
        } else {
            startpoint = 92;                
        }

        if (scroll_pos >= startpoint) {
            if (visible === false) {
	            el.classList.add('is-visible');
	            visible = true;
            }
        }
        
        else if (scroll_pos <= startpoint) {
            el.classList.remove('is-visible');
            visible = false;
        }
    };
    
    if (el) {
        if (!document.body.classList.contains('js-show-toolbar')) {
            action();
            window.addEventListener('scroll', action);
        } else {
            el.classList.add('is-visible');
        }
    }
    
}, false);
